import React, { useContext, useState } from "react";

import { Link } from "react-router-dom";
import { Row, Col, Form, FloatingLabel, Button } from "react-bootstrap";
import PageLayout from "../../../layouts/PageLayout";
import "react-form-wizard-component/dist/style.css";

export default function AddReligiousAssociation() {
  const [values, setValues] = useState({
    selectFamily: "",
    selectPlace: "",
    isBaptized: "",
    medicalReason: "",
  });

  const tabChanged = ({ prevIndex, nextIndex }) => {
    if (nextIndex !== prevIndex) {
      window.scrollTo({
        top: 0,
        behavior: "smooth", // Adds a smooth scrolling effect
      });
    }
    console.log("prevIndex", prevIndex);
    console.log("nextIndex", nextIndex);
  };

  const handleChange = (e) => {
    const { name, value, type, files } = e.target;
    if (type === "file") {
      setValues((prevState) => ({
        ...prevState,
        [name]: Array.from(files),
      }));
    } else {
      setValues((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(values);
  };

  return (
    <PageLayout>
      <Row>
        <Col xl={12}>
          <div className="mc-card">
            <div className="mc-breadcrumb">
              <h3 className="mc-breadcrumb-title">
                {"Add Religious Association"}
              </h3>
              <ul className="mc-breadcrumb-list">
                <li className="mc-breadcrumb-item">
                  <Link to="#" className="mc-breadcrumb-link">
                    {"home"}
                  </Link>
                </li>
                <li className="mc-breadcrumb-item">
                  <Link to="#" className="mc-breadcrumb-link">
                    {"Religious Assoc..."}
                  </Link>
                </li>
                <li className="mc-breadcrumb-item">
                  {"Add New Religious Association"}
                </li>
              </ul>
            </div>
          </div>
        </Col>
      </Row>

      <div className="card">
        <div className="card-header">Add Religious Association</div>
        <div className="card-body">
          <form onSubmit={handleSubmit}>
            <Row>
              <Form.Group as={Col} md="4" controlId="validationCustom01">
                <FloatingLabel
                  controlId="floatingTextarea"
                  label="Select Family"
                  className="mb-3"
                >
                  <Form.Select
                    required
                    type="text"
                    name="selectFamily"
                    placeholder=""
                    value={values.selectFamily}
                    onChange={handleChange}
                  >
                    <option>Select...</option>
                    <option>FSF 1</option>
                    <option>FSF 2</option>
                  </Form.Select>
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="4" controlId="validationCustom01">
                <FloatingLabel
                  controlId="floatingTextarea"
                  label="Select Place"
                  className="mb-3"
                >
                  <Form.Select
                    required
                    type="text"
                    name="selectPlace"
                    placeholder=""
                    value={values.selectPlace}
                    onChange={handleChange}
                  >
                    <option>Select Family First...</option>
                    <option>Place 1</option>
                    <option>Place 2 </option>
                  </Form.Select>
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="4" controlId="validationCustom01">
                <FloatingLabel
                  controlId="floatingTextarea"
                  label="Baptized"
                  className="mb-3"
                >
                  <Form.Select
                    required
                    type="text"
                    name="isBaptized"
                    placeholder=""
                    value={values.isBaptized}
                    onChange={handleChange}
                  >
                    <option>Select...</option>
                    <option> Yes </option>
                    <option> No </option>
                  </Form.Select>
                </FloatingLabel>
              </Form.Group>
              <Form.Group className="mb-4" controlId="formFileMultiple">
                <FloatingLabel>
                  <FloatingLabel label="Images(Multiple)">
                    <Form.Control
                      required
                      multiple
                      name="baptizeImages"
                      onChange={handleChange}
                      type="file"
                      placeholder="baptize-images"
                      style={{ height: "60px" }}
                    />
                  </FloatingLabel>
                </FloatingLabel>
              </Form.Group>
              {/* Add Video  */}
              <Form.Group>
                <FloatingLabel
                  controlId="floatingInputGrid"
                  label="Comments"
                  className="text-bold"
                >
                  <Form.Control
                    as="textarea"
                    required
                    type="text"
                    name="medicalReason"
                    value={values.medicalReason}
                    onChange={handleChange}
                    placeholder="Medical Reason"
                    style={{ height: "60px" }}
                  />
                </FloatingLabel>
              </Form.Group>
            </Row>
            <Button className="py-2 my-3" variant="success" type="submit">
              Submit
            </Button>
          </form>
        </div>
      </div>
    </PageLayout>
  );
}
